const _get = require('lodash/get')

const patchCountryCode = phoneNumber => {
  if (phoneNumber === undefined || phoneNumber === null) {
    return ''
  }
  const numberAsString = String(phoneNumber)
  return !numberAsString.startsWith('+') && numberAsString.length === 8
    ? `+65${numberAsString}`
    : numberAsString
}

const stripCountryCode = phoneNumber => {
  if (phoneNumber === undefined || phoneNumber === null) {
    return ''
  }
  const numberAsString = String(phoneNumber)
  return numberAsString.replace(/^\+(?:65)?/, '');
}

const mapSingleAddressDataOld2New = (add, isDefault = false) => ({
  addresseeName: _get(add, 'metaData.FirstName'),
  city: _get(add, 'city'),
  id: _get(add, 'id'),
  latitude: String(_get(add, 'latitude')),
  longitude: String(_get(add, 'longitude')),
  isDefault: isDefault,
  phoneNumber: patchCountryCode(_get(add, 'metaData.Phone')),
  postalCode: _get(add, 'pincode'),
  streetAddress: _get(add, 'address'),
  companyName: _get(add, 'companyName'),
  type: _get(add, 'type'),
  buildingName: _get(add, 'metaData.BuildingName') || '',
  ...(_get(add, 'metaData.Floor') && {
    floorNumber: _get(add, 'metaData.Floor'),
  }),
  ...(_get(add, 'metaData.Unit') && {
    unitNumber: _get(add, 'metaData.Unit'),
  }),
  // for checkout flow only
  ...(_get(add, 'storeId') && { storeId: _get(add, 'storeId') }),
})

const mapSingleAddressApiResNew2Old = add => ({
  address: _get(add, 'streetAddress'),
  city: _get(add, 'city'),
  id: _get(add, 'id'),
  latitude: _get(add, 'latitude'),
  longitude: _get(add, 'longitude'),
  type: _get(add, 'type'),
  companyName: _get(add, 'companyName'),
  metaData: {
    FirstName: _get(add, 'addresseeName'),
    Phone: patchCountryCode(_get(add, 'phoneNumber')),
    ...(_get(add, 'buildingName') && {
      BuildingName: _get(add, 'buildingName'),
    }),
    ...(_get(add, 'floorNumber') && { Floor: _get(add, 'floorNumber') }),
    ...(_get(add, 'unitNumber') && { Unit: _get(add, 'unitNumber') }),
  },
  pincode: _get(add, 'postalCode'),
})

const mapMultipleAddressApiResNew2Old = newFormatAsArray => {
  const oldFormatAsArray = []
  let defaultAddress = {}

  newFormatAsArray.map(add => {
    const tempAddress = mapSingleAddressApiResNew2Old(add)
    if (add.isDefault) {
      defaultAddress = tempAddress
    }
    oldFormatAsArray.push(tempAddress)
  })

  return {
    addresses: oldFormatAsArray,
    defaultAddress: defaultAddress,
  }
}

const mapAddressFormDataNew2Old = formData => ({
  address: _get(formData, 'streetAddress'),
  city: _get(formData, 'city'),
  companyName: _get(formData, 'companyName'),
  contactName: _get(formData, 'addresseeName'),
  contactPhone: stripCountryCode(_get(formData, 'phoneNumber')),
  floor: _get(formData, 'floorNumber'),
  hasFloorUnit: _get(formData, 'hasFloorUnit'),
  id: _get(formData, 'id'),
  latitude: _get(formData, 'latitude'),
  longitude: _get(formData, 'longitude'),
  metaData: {
    FirstName: _get(formData, 'addresseeName'),
    Phone: _get(formData, 'phoneNumber'),
  },
  type: _get(formData, 'type'),
  unit: _get(formData, 'unitNumber'),
  pincode: _get(formData, 'postalCode'),
  storeId: _get(formData, 'storeId'),
})

module.exports = {
  patchCountryCode,
  stripCountryCode,
  mapSingleAddressDataOld2New,
  mapSingleAddressApiResNew2Old,
  mapMultipleAddressApiResNew2Old,
  mapAddressFormDataNew2Old,
}
